import React from 'react'
import { useTranslation } from 'react-i18next'
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import RecordHistoryCard from '../components/RecordHistoryCard'

interface Props {
  projectId: string
  node: { id: string; code: string | null; name: string } | null
  currency: string
  locale: string
  onClose: () => void
}

/** 1b-C spec §5: one budget row's history. Approved budget changes stay in the revised budget's breakdown. */
const NodeHistorySheet: React.FC<Props> = ({ projectId, node, currency, locale, onClose }) => {
  const { t } = useTranslation()
  return (
    <Sheet open={!!node} onOpenChange={(open) => { if (!open) onClose() }}>
      <SheetContent side="right" className="w-full overflow-y-auto sm:max-w-xl">
        {node && (
          <>
            <SheetHeader>
              <SheetTitle>{t('CostControl_node_history')}</SheetTitle>
              <SheetDescription>{node.code ? `${node.code} · ${node.name}` : node.name}</SheetDescription>
            </SheetHeader>
            <div className="mt-4">
              <RecordHistoryCard projectId={projectId} entityType="NODE" entityId={node.id} currency={currency} locale={locale} />
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  )
}
export default NodeHistorySheet
